import { Box, Typography, Collapse } from '@mui/material';
import { useState } from 'react';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import PropTypes from 'prop-types';
import fieldMappingIcon from './images/Field-mapping.png';
import noTransformationIcon from './images/No-transformation.svg';
import decisionIcon from './images/decision_icon.svg';
import jiraIcon from './images/JIRA.svg';

export default function IntegrationSection() {
  const [open, setOpen] = useState(true);

  return (
    <Box>
      {/* Integration Header */}
      <Box
        onClick={() => setOpen(!open)}
        sx={{
          background: 'linear-gradient(100.009deg, rgb(232, 250, 244) 10.544%, rgba(232, 250, 244, 0.2) 149%)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          px: 0.75,
          py: 0.5,
          cursor: 'pointer',
          mb: open ? 3 : 0
        }}
      >
        <Typography
          sx={{
            fontFamily: 'IBM Plex Sans, sans-serif',
            fontWeight: 500,
            fontSize: '0.9375rem',
            color: '#525252',
          }}
        >
          Integration
        </Typography>
        <KeyboardArrowUpIcon 
          sx={{ 
            fontSize: 18, 
            color: '#525252',
            transform: open ? 'none' : 'rotate(180deg)',
            transition: 'transform 0.2s'
          }} 
        />
      </Box>

      {/* Integration Content */}
      <Collapse in={open}>
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
          {/* Row 1: Field Mapping & No Transformation */}
          <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
            <IntegrationItem 
              iconSrc={fieldMappingIcon}
              label="Field Mapping"
            />
            <IntegrationItem 
              iconSrc={noTransformationIcon}
              label="No Transformation"
            />
          </Box>

          {/* Row 2: Decision Mapping & Jira */}
          <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
            <IntegrationItem 
              iconSrc={decisionIcon}
              label="Decision Mapping"
            />
            <IntegrationItem 
              iconSrc={jiraIcon}
              label="Jira"
            />
          </Box>
        </Box>
      </Collapse>
    </Box>
  );
}

function IntegrationItem({ iconSrc, label }) {
  const handleDragStart = (e) => {
    e.dataTransfer.setData('application/reactflow', label);
    e.dataTransfer.setData('nodeType', 'Integretion');
    e.dataTransfer.effectAllowed = 'move';
  };

  const width = label === 'Field Mapping' || label === 'Decision Mapping' ? 97 : 103;

  return (
    <Box 
      sx={{ 
        display: 'flex', 
        flexDirection: 'column', 
        alignItems: 'center', 
        gap: 1,
        width
      }}
      draggable
      onDragStart={handleDragStart}
    >
      <Box
        component="img"
        src={iconSrc}
        alt={`${label} icon`}
        sx={{
          width: 26,
          height: 26,
          border: '0.8px solid #525252',
          borderRadius: '2px',
          objectFit: 'contain',
          p: 0.5,
          backgroundColor: 'white'
        }}
      />
      <Typography
        sx={{
          fontFamily: 'IBM Plex Sans, sans-serif',
          fontWeight: 500,
          fontSize: '0.75rem',
          color: '#525252',
          textAlign: 'center',
          lineHeight: 1.4,
          whiteSpace: label === 'No Transformation' ? 'nowrap' : 'normal'
        }}
      >
        {label}
      </Typography>
    </Box>
  );
}

IntegrationItem.propTypes = {
  iconSrc: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired
};
